import { Button, Typography, useMediaQuery } from "@mui/material";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../routing/Routing";
import { ONBOARDING_STEPS, ROUTES, VIEWS } from "../constants/user-info.const";
import { connect } from "react-redux";
import UnsaveChangeDialog from "../user-details/UnsaveChangeDialog";
import { UNSAVE_DIALOG_ACTIONS } from "../user-details/models/user-interface";
import store from "../../store";
import { SET_IS_NAV_FROM_MENU } from "../../store/actions/navigationFromMenu";

function AppToolbar(props: any) {
  const location = useLocation();
  const { viewName, setViewName } = useContext(AppContext);
  const smDevice = useMediaQuery("(max-width:600px)");
  const { onBoardingSteps, formRef } = props;
  const expiryDate = localStorage.getItem("expiryDate");
  const navigate = useNavigate();
  const [showUnsaveChangeDalog, setShowUnsaveChangeDalog] = useState(false);
  const [routeName, setRouteName] = useState("");
  
  const activatedClass = (path: string): string => {
    return location.pathname === path ? "active-route" : "";
  };

  const submitFormData = () => {
    formRef.current.submitForm();
  };
  const dispatchIsNavToStore = (isNav : boolean) =>{
    store.dispatch({
      type: SET_IS_NAV_FROM_MENU,
      state: isNav
    });
}
  const handleUnsavedWanringModalAction = (action: string) => {
    if (!action) return;
    if (action === UNSAVE_DIALOG_ACTIONS.DISCARD) {
      setShowUnsaveChangeDalog(false);
      navigate(routeName);
      return;
    }
    if (action === UNSAVE_DIALOG_ACTIONS.KEEP_EDITING) {
      setShowUnsaveChangeDalog(false); 
      return;
    }
    setShowUnsaveChangeDalog(false);
    submitFormData();
  };
  const checkIfFormDirty = (): boolean => {
   return formRef.current?.dirty;
  };
  const getCurrentStep = () : string =>{
      const stepsInOrder = [
        'personal_info',
        'home_address',
        'federal_tax_info',
        'state_taxes',
        'payment_method',
        'review_info',
        'tos_acceptance',
        'e_sign_form'
      ];
      for(const step of stepsInOrder){
        if(onBoardingSteps[step] === false){
          return step;
        }
      }
      return '';
  }
  const isCurrentStep = (step : string) : boolean =>{
    return getCurrentStep() === step;
  }
  const currentStepClass = (step : string) =>{
    return isCurrentStep(step) ? 'current-step' : '';
  }
  const setDisplayForm = (formName: string, step: string): void => {
    if(!onBoardingSteps[step] && !isCurrentStep(step)) return;
    dispatchIsNavToStore(false);
    if (smDevice) {
      setViewName(formName);
      return;
    }
    if (!checkIfFormDirty()) {
      navigate("/" + formName);
      return;
    }
    setRouteName("/" + formName);
    setShowUnsaveChangeDalog(true);
  };
  const completedStep = (step : string): string => {
    if (!onBoardingSteps) return "";
    return onBoardingSteps[step] ? "completed-step" : "";
  };
  
  const toolbarMenu = () => {
    return (
      <div className="toolbar">
        <div className="toolbar--leftMenu">
          <h3 className="toolbar--leftMenu__header">
            Complete your payroll profile
          </h3>
          <p className="toolbar--leftMenu__timeline">
            Complete before: {expiryDate}
          </p>
          <ul className="toolbar--leftMenu__items">
            <li
              className={
                activatedClass(ROUTES.personalInfo) +
                " " +
                completedStep(ONBOARDING_STEPS.personalInfo) +
                " "+
                currentStepClass(ONBOARDING_STEPS.personalInfo)
              }
              onClick={() => {
                setDisplayForm(VIEWS.personalInfo, ONBOARDING_STEPS.personalInfo);
              }}
            >
              Personal Info
            </li>
            <li
              className={
                activatedClass(ROUTES.homeAddress) +
                " " +
                completedStep(ONBOARDING_STEPS.homeAddress) +
                " "+
                currentStepClass(ONBOARDING_STEPS.homeAddress)
              }
              onClick={() => {
                setDisplayForm(VIEWS.homeAddress, ONBOARDING_STEPS.homeAddress);
              }}
            >
              Home Address
            </li>

            <li
              className={
                activatedClass(ROUTES.federalTaxes) +
                " " +
                completedStep(ONBOARDING_STEPS.federalTaxes)+
                " "+
                currentStepClass(ONBOARDING_STEPS.federalTaxes)
              }
              onClick={() => {
                setDisplayForm(VIEWS.federalTaxes, ONBOARDING_STEPS.federalTaxes);
              }}
            >
              Federal Taxes
            </li>
            <li
              className={
                activatedClass(ROUTES.stateTaxes) +
                " " +
                completedStep(ONBOARDING_STEPS.stateTaxes)+
                " "+
                currentStepClass(ONBOARDING_STEPS.stateTaxes)
              }
              onClick={() => {
                setDisplayForm(VIEWS.stateTaxes, ONBOARDING_STEPS.stateTaxes);
              }}
            >
              State Taxes
            </li>
            <li
              className={
                activatedClass(ROUTES.paymentMethod) +
                " " +
                completedStep(ONBOARDING_STEPS.paymentMethod)+
                " "+
                currentStepClass(ONBOARDING_STEPS.paymentMethod)
              }
              onClick={() => {
                setDisplayForm(VIEWS.paymentMethod, ONBOARDING_STEPS.paymentMethod);
              }}
            >
              Payment Method
            </li>
            <li
              className={
                activatedClass(ROUTES.reviewInfo) +
                " " +
                completedStep(ONBOARDING_STEPS.reviewInfo)+
                " "+
                currentStepClass(ONBOARDING_STEPS.reviewInfo)
              }
              onClick={() => {
                setDisplayForm(VIEWS.reviewInfo, ONBOARDING_STEPS.reviewInfo);
              }}
            >
              Review Info
            </li>

            <li
              className={
                activatedClass(ROUTES.termsOfService) +
                " " +
                completedStep(ONBOARDING_STEPS.termsOfService)+
                " "+
                currentStepClass(ONBOARDING_STEPS.termsOfService)
              }
              onClick={() => {
                setDisplayForm(VIEWS.termsOfService, ONBOARDING_STEPS.termsOfService);
              }}
            >
              Terms of Service
            </li>

            <li
              className={
                activatedClass(ROUTES.eSign) +
                " " +
                completedStep(ONBOARDING_STEPS.eSign)+
                " "+
                currentStepClass(ONBOARDING_STEPS.eSign)
              }
              onClick={() => {
                setDisplayForm(VIEWS.eSign, ONBOARDING_STEPS.eSign);
              }}
            > 
              E-Sign
            </li>
          </ul>
        </div>
        <div className="toolbar--footerMobile">
          <Button variant="contained" className="btn-primary" disabled>
            <Typography variant="button">Send to Employer</Typography>
          </Button>
        </div>
        {showUnsaveChangeDalog && (
          <UnsaveChangeDialog
            showUnsavedModal={showUnsaveChangeDalog}
            handleUnsavedWanringModalAction={handleUnsavedWanringModalAction}
          />
        )}
      </div>
    );
  };
  const showToolbar = () => {
    if (!smDevice) {
      return toolbarMenu();
    }
    if (!viewName || viewName === VIEWS.toolbar) {
      return toolbarMenu();
    }
  };
  return <>{showToolbar()}</>;
}
const mapStateToProps = (state) => ({
  onBoardingSteps: state.steps.onBoardingSteps
});
export default connect(mapStateToProps)(AppToolbar);
